import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useContext, useMemo} from 'react'
import {NavigationContext} from './NavigationContext'
import {Roles, hasPermission} from 'utility/utility'

export const Navigation = () => {
  const {title} = useContext(NavigationContext)
  const location = useLocation()
  const navigate = useNavigate()

  const showShowTabs = useMemo(() => {
    const segments = location.pathname.split('/').filter(segment => !!segment)
    return segments.length === 1 && ['distributor', 'reseller', 'business'].includes(segments[0])
  }, [location])

  const getActiveClass = path => {
    return location.pathname === path ? 'active' : ''
  }

  return !showShowTabs ? (
    <div className="vw-dashboard__main__title sticky-top">
      <button className="btn btn-link text-decoration-none" onClick={() => navigate(-1)}>
        <i className="fal fa-arrow-left mr-1"></i>Back
      </button>
      <span>{title}</span>
    </div>
  ) : (
    <div className="vw-type-menu-wrapper sticky-top">
      <nav className="vw-type-menu">
        <ul>
          {hasPermission(Roles.superAdmin) && (
            <li>
              <Link to="distributor" className={getActiveClass('/distributor')}>
                Distributors
              </Link>
            </li>
          )}

          {hasPermission(Roles.distributor) && (
            <li>
              <Link to="reseller" className={getActiveClass('/reseller')}>
                Resellers
              </Link>
            </li>
          )}

          {hasPermission(Roles.reseller) && (
            <li>
              <Link to="business" className={getActiveClass('/business')}>
                Businesses
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  )
}
